import { render } from "./ToastTip.vue?vue&type=template&id=238ca010"
import script from "./ToastTip.vue?vue&type=script&lang=js"
export * from "./ToastTip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__